module.exports = __webpack_public_path__ + "static/media/tire-green-5.74aaf792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tire-green-5.png
// module id = 1145
// module chunks = 0